
import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ProjectsSection from './components/ProjectsSection';
import ARExperienceSection from './components/ARExperienceSection';
import FurnitureCollectionSection from './components/FurnitureCollectionSection';
import NewsSection from './components/NewsSection';
import ExteriorPrefabSection from './components/ExteriorPrefabSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from '../../components/feature/Footer';
import Navbar from '../../components/feature/Navbar';

export default function HomePage() {
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIntro(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Corporate Intro Animation */}
      {showIntro && (
        <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center overflow-hidden">
          <div className="relative">
            {/* Main ERNADO Text */}
            <div className="animate-fade-scale">
              <h1 
                className="text-6xl md:text-7xl lg:text-8xl font-extralight tracking-[0.3em] text-center"
                style={{ 
                  fontFamily: "'Playfair Display', serif",
                  background: 'linear-gradient(135deg, #D4AF37 0%, #F5E6D3 50%, #C9A961 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  textShadow: '0 0 40px rgba(212, 175, 55, 0.2)'
                }}
              >
                ERNADO
              </h1>
            </div>

            {/* Subtle Line Animation */}
            <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 w-0 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent animate-line-expand"></div>
          </div>

          {/* Minimal Corner Accents */}
          <div className="absolute top-8 left-8 w-12 h-12 border-t border-l border-[#D4AF37]/30 animate-fade-in"></div>
          <div className="absolute top-8 right-8 w-12 h-12 border-t border-r border-[#D4AF37]/30 animate-fade-in"></div>
          <div className="absolute bottom-8 left-8 w-12 h-12 border-b border-l border-[#D4AF37]/30 animate-fade-in"></div>
          <div className="absolute bottom-8 right-8 w-12 h-12 border-b border-r border-[#D4AF37]/30 animate-fade-in"></div>
        </div>
      )}

      {/* Main Content */}
      <div className={`min-h-screen bg-white transition-opacity duration-1000 ${showIntro ? 'opacity-0' : 'opacity-100'}`}>
        <Navbar />
        <HeroSection />
        <ProjectsSection />
        <ARExperienceSection />
        <FurnitureCollectionSection />
        <NewsSection />
        <ExteriorPrefabSection />
        <TestimonialsSection />
        <Footer />
      </div>
    </>
  );
}
